// The booking waiting in the pill (New Booking, minimised), as the diary
// previews it: hovering a column shows where it would land, its full length
// and who it's for, before the tap that moves it there.
//   { duration, label }  or null when no booking is tucked away
import { useEffect, useState } from 'react'

let current = null
const listeners = new Set()

export const setDraftPreview = (v) => {
  current = v ? { ...v } : null
  listeners.forEach(fn => fn(current))
}
export const getDraftPreview = () => current

export const useDraftPreview = () => {
  const [v, setV] = useState(current)
  useEffect(() => {
    listeners.add(setV)
    setV(current)
    return () => { listeners.delete(setV) }
  }, [])
  return v
}
